import { call, put } from 'redux-saga/effects';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { DraftsTelemetry } from '~src/drafts/telemetry/DraftsTelemetry';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { ExtractDraftAvaliableDialog } from '../../extract/components/ExtractDraftAvaliableDialog';
import { EditWorkbookAction } from '../actions/EditWorkbookAction';
import { fetchWorkbookById } from './WorkbookSagasHelper';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit workbook saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards
export function* handleEditWorkbookAction(action: EditWorkbookAction) {
  let userExtractDraft = false;
  let workbookInfo: any = null;
  // Encapsulating the calls to get the workbook data
  try {
    workbookInfo = yield call(fetchWorkbookById, action.workbook.id);
    if (!_.isUndefined(workbookInfo?.editExtractDraftUrl)) {
      userExtractDraft = yield call(ExtractDraftAvaliableDialog.open);
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
    // Log the error in telemetry
    if (action.draftOrigin) {
      yield call(DraftsTelemetry.sendDraftsOpenEvent, {
        success: false,
        error_message: JSON.stringify(e),
        origin: action.draftOrigin,
        workbook_luid: action.workbook.luid,
      });
    }
    // Don't proceed to opening a new window if network calls fail
    return;
  }
  // Safari and Firefox block popups so we can show a specific toast
  // asking users to allow popups.
  // Adds the url as a parameter to 'open' so if they select "allow popups" it will open
  // the url
  const newTab: Window = userExtractDraft ? WindowLocationService.open(workbookInfo.editExtractDraftUrl)
    : WindowLocationService.open(workbookInfo?.editUrl);
  if (newTab) {
    if (action.draftOrigin) {
      yield call(DraftsTelemetry.sendDraftsOpenEvent, {
        success: true,
        origin: action.draftOrigin,
        workbook_luid: action.workbook.luid,
      });
    }
  } else {
    ToasterService.instance.pop({
      type: ToastType.Info,
      text: Messages.editWorkbook_popupRequest(),
      testId: 'edit-workbook-popup-request'
    });
  }
}
